import { PaymentPoint } from './constants';

export interface BasePaymentSelectDetailsProps {
  title: string;
  points: PaymentPoint[];
  footerHeading: string;
  footerSubheading: string;
}

const BasePaymentSelectDetails: React.FunctionComponent<BasePaymentSelectDetailsProps> =
  function ({ title, points, footerHeading, footerSubheading }) {
    return (
      <div className="flex flex-col w-full text-left gap-y-1 md:gap-y-2">
        <h4 className="text-12-18 md:text-14-22 text-neutral-700 mb-1">
          {title}
        </h4>
        {points.map(({ icon, text }) => (
          <div className="flex flex-row gap-x-2" key={text}>
            {icon}
            <span className="text-12-18 text-neutral-700 md:mt-px">{text}</span>
          </div>
        ))}
        <div className="my-2 md:my-3 border-b border-neutral-300" />
        <div className="flex flex-col items-center">
          <h2 className="text-18-22-b md:text-20-24-b">{footerHeading}</h2>
          <h4 className="text-12-18 md:text-14-22 text-neutral-700">
            {footerSubheading}
          </h4>
        </div>
      </div>
    );
  };

export default BasePaymentSelectDetails;
